module.exports = __webpack_public_path__ + "fonts/montserrat-regular.c0b8804ae85213c9194816da945db150.woff";